<template>
  <div
  v-bind:class="{menuVisible: isMenuActive}" 
  class="home">

    <!-- Playback time picker comp -->
    <div 
    v-if="!isPlaybackTimePickerClosed"
    class="playback-time-picker-comp-container">
      <playback-time-picker-comp
      v-on:onClose="closePlaybackTimePicker()"
      ></playback-time-picker-comp>
    </div>

    <transition name="moveup" mode="out-in" appear>
    <!-- Camera comp -->
    <camera-comp
    v-if="!isCameraComponentClosed"
    v-on:onClose="closeCameraComponent()"
    v-bind:cameraObj="channels[selectedCamera]"
    v-bind:isActive="!isCameraComponentClosed"
    ></camera-comp><!-- Camera comp -->
    </transition>

    <!-- Clickable layer -->
    <div 
    v-on:click="closeMenu()"
    v-bind:class="{menuVisible: isMenuActive}" 
    class="clickable-layer-to-close-menu"></div>

    <!-- Menu -->
    <div class="menu">
      <!-- <div class="menu-items">
        <div class="menu-category">Bridge</div>
        <div 
        ontouchstart=""
        v-on:click="onClickBridge(mac)"
        v-for="(bridge, mac) in bridges"
        v-bind:key="mac"
        v-bind:class="{
          'offline': !bridge.isOnline,
          'selected': mac === selectedBridge
        }"
        class="menu-item">
          <div class="menu-icon">
            <svg 
            v-if="!bridge.isAuthenticated"
            fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0h24v24H0z" fill="none"/>
              <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
            </svg>
            <svg 
            v-if="bridge.isAuthenticated"
            fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0h24v24H0z" fill="none"/>
              <path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"/>
            </svg>
          </div>
          <div class="menu-info">
            <div class="main-info">{{bridge.name}}</div>
            <div class="sub-info">{{bridge.mac}}</div>
            <div class="sub-info">{{bridge.isOnline ? 'online' : 'offline'}}</div>
          </div>
        </div>
      </div> -->
      <div class="menu-items">
        <div class="menu-category">Site</div>
        <div 
        ontouchstart=""
        v-for="(site, siteId) in mySites"
        v-bind:key="siteId"
        v-on:click="selectSite(siteId)"
        class="menu-item">
          <div class="menu-icon">
            <svg 
            fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0h24v24H0z" fill="none"/>
              <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
            </svg>
          </div>
          <div class="menu-info">
            <div class="main-info">{{site.name}}</div>
            <div class="sub-info">{{site.address}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main -->
    <div class="main">

      <!-- Header -->
      <div class="header">
        <!-- Menu button -->
        <div 
        v-bind:class="{active: isMenuActive}" 
        v-on:click="onClickMenu()" 
        class="menu-btn" ontouchstart="">
          <div class="bar first">&nbsp;</div>
          <div class="bar second">&nbsp;</div>
          <div class="bar third">&nbsp;</div>
          <div class="bar fourth">&nbsp;</div>
        </div>
        <!-- Menu title -->
        <div 
        v-if="currentSiteId"
        class="header-title">
          {{currentSite.localTimeNow().toLocaleTimeString()}}
        </div>
      </div>

      <!-- Body -->
      <div class="body">

        <!-- Offline -->
        <div 
        v-if="!bridges[selectedBridge].isOnline"
        class="wrapper">
          <div class="offline-container">
            <div class="status-text">Can't connect to the bridge.</div>
            <div 
            v-on:click="checkBridgeConnection(selectedBridge)"
            v-bind:class="{'disable-click': bridges[selectedBridge].isCheckingConnection}"
            class="action-btn">
              <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
                <path d="M0 0h24v24H0z" fill="none"/>
              </svg>
              {{bridges[selectedBridge].isCheckingConnection ? 'Checking status...' : 'Refresh status'}}
            </div>
          </div>
        </div><!-- Offline -->

        <!-- Authentication required -->
        <div 
        v-else-if="!bridges[selectedBridge].isAuthenticated"
        class="wrapper">
          <div class="authentication-container">
            <div class="status-text">Authentication</div>
            <div class="input-container">
              <input 
              v-on:keyup.enter="authenticateBridgeConnection(selectedBridge)"
              v-model="bridges[selectedBridge].authUsername"
              type="text" placeholder="Enter username">
              <input 
              v-on:keyup.enter="authenticateBridgeConnection(selectedBridge)"
              v-model="bridges[selectedBridge].authPassword"
              type="password" placeholder="Enter password">
            </div>
            <div 
            v-on:click="authenticateBridgeConnection(selectedBridge)"
            v-bind:class="{'disable-click': bridges[selectedBridge].isAuthenticating}"
            class="action-btn">
              {{bridges[selectedBridge].isAuthenticating ? 'Authenticating...' : 'Authenticate'}}
            </div>
            <div
            v-bind:class="{'visible': bridges[selectedBridge].authError}" 
            class="error-text">
              {{bridges[selectedBridge].authError ? bridges[selectedBridge].authError : 'no message' }}
            </div>
          </div>
        </div><!-- Authentication required -->

        <!-- Show camera -->
        <div 
        v-else
        class="wrapper">
          <!-- <div class="cameras-container">
            <div 
            v-for="(channelData, channelNumber) in channels"
            v-bind:key="channelNumber"
            v-on:click="onClickCamera(channelNumber)"
            class="camera-container">
              <div class="content">
                <div class="camera-info">
                  <div class="camera-name prevent-text-overflow">
                    <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0h24v24H0z" fill="none"/>
                      <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
                    </svg>
                    CH{{channelNumber}} - {{channelData.name}}
                  </div>
                  <div class="updated-info">
                    <div class="updated-info-description">Last updated</div>
                    <div class="updated-info-time">{{currentTime.toLocaleTimeString()}}</div>
                  </div>
                </div>
                <div 
                v-if="!channelData.isOnline"
                class="svg-icon">
                  <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0zm0 0h24v24H0z" fill="none"/>
                    <path d="M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"/>
                  </svg>
                </div>
                <img 
                v-if="channelData.isOnline"
                v-bind:src="channelData.liveSnapshotUrl">
              </div>
            </div>
          </div> -->
          <div 
          v-if="currentSiteId"
          class="cameras-container">
            <div
            v-for="cameraId in currentSite.cameras" 
            v-bind:key="cameraId"
            class="camera-container">
              <div class="content">
                <div class="camera-info">
                  <div class="camera-name prevent-text-overflow">
                    <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0h24v24H0z" fill="none"/>
                      <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
                    </svg>
                    {{camera(cameraId).name}}
                  </div>
                  <div class="updated-info">
                    <div class="updated-info-description">Last updated</div>
                    <div class="updated-info-time">
                      {{liveSnapshot(cameraId) ? currentSite.convertToLocalTime(liveSnapshot(cameraId).timestamp).toLocaleTimeString() : 'no info'}}
                    </div>
                  </div>
                </div>
                <div 
                v-if="!camera(cameraId).isOnline"
                class="svg-icon">
                  <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0zm0 0h24v24H0z" fill="none"/>
                    <path d="M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"/>
                  </svg>
                </div>
                <img 
                v-if="camera(cameraId).isOnline && liveSnapshot(cameraId)"
                v-bind:src="'data:image/jpg;base64,' + liveSnapshot(cameraId).url">
              </div>
            </div>
          </div>
        </div><!-- Show camera -->

      </div>


    </div>
  </div>
</template>

<script>
import PlaybackTimePickerComp from './PlaybackTimePickerComp'
import CameraComp from './CameraComp'

export default {
  name: 'home',
  components: { PlaybackTimePickerComp, CameraComp },
  created: function () {
    this.initializeMockupData()
  },
  destoryed: function () {
    this.stopRefreshingSiteLiveSnapshots()
  },
  data () {
    return {
      refreshingSiteLiveSnapshot$i: null,
      selectedBridge: null,
      isMenuActive: false,
      isPlaybackTimePickerClosed: true,
      isCameraComponentClosed: true,
      playingTime: null,
      playingDate: null,
      selectedCamera: null,
      bridges: {},
      channels: {}
    }
  },
  computed: {
    currentTime: function () {
      return new Date()
    },
    myName: function () {
      return this.$store.getters.myName
    },
    mySites: function () {
      return this.$store.getters.mySites
    },
    currentSiteId: function () {
      return this.$store.getters.currentSiteId
    },
    currentSite: function () {
      return this.$store.getters.currentSite
    },
    camera: function () {
      return this.$store.getters.camera
    },
    statusGetLiveSnapshot: function () {
      return this.$store.getters.statusGetLiveSnapshot
    },
    liveSnapshot: function () {
      return this.$store.getters.liveSnapshot
    },
    historyRetentionDay: function () {
      return this.$store.getters.historyRetentionDay
    },
    statusGetMySites: function () {
      return this.$store.getters.statusGetMySites
    },
    mySitesCount: function () {
      return this.$store.getters.mySitesCount
    }
  },
  methods: {
    selectSite: function (siteId) {
      this.$store.dispatch('selectSite', siteId)
      this.startRefreshingSiteLiveSnapshots(siteId)
    },
    startRefreshingSiteLiveSnapshots: function (siteId) {
      let refreshInterval = 1000 * 5 // 5 sec
      this.stopRefreshingSiteLiveSnapshots()
      setTimeout(() => { this.getSiteLiveSnapshots(siteId) }, 1000)
      this.refreshingSiteLiveSnapshot$i = setInterval(() => {
        this.getSiteLiveSnapshots(siteId)
        // re-render whole page only every 5 seconds (it doesn't work in iphone safari)
        this.$forceUpdate()
      }, refreshInterval)
    },
    stopRefreshingSiteLiveSnapshots: function () {
      if (this.refreshingSiteLiveSnapshot$i) {
        clearInterval(this.refreshingSiteLiveSnapshot$i)
        this.refreshingSiteLiveSnapshot$i = null
      }
    },
    getSiteLiveSnapshots: function (siteId) {
      if (this.currentSite.cameras) {
        this.currentSite.cameras.map(cameraId => {
          if (
            this.camera(cameraId).isOnline &&
            this.statusGetLiveSnapshot(cameraId) !== 'requested'
          ) {
            this.$store.dispatch('getLiveSnapshot', cameraId)
          }
        })
      }
    },
    getAmPm: function (hourIndex) {
      if (hourIndex < 12) return 'AM'
      else return 'PM'
    },
    initializeMockupData: function () {
      this.playingTime = '11:32:42AM'
      this.playingDate = 'May 31'
      this.bridges = {
        '5805590F3848': {
          name: 'Bridge warehouse #1',
          mac: '5805590F3848',
          isOnline: 1,
          isCheckingConnection: 0,
          isAuthenticated: 1,
          isAuthenticating: 0,
          authError: 0,
          authUsername: null,
          authPassword: null,
          username: 'chekt',
          password: 'chekt'
        },
        '2314442034A3': {
          name: 'Bridge warehouse #2',
          mac: '2314442034A3',
          isOnline: 1,
          isCheckingConnection: 0,
          isAuthenticated: 1,
          isAuthenticating: 0,
          authError: 0,
          authUsername: null,
          authPassword: null,
          username: 'chekt',
          password: 'chekt'
        },
        '7D28A840579B': {
          name: 'Bridge #1',
          mac: '7D28A840579B',
          isOnline: 0,
          isCheckingConnection: 0,
          isAuthenticated: 0,
          isAuthenticating: 0,
          authError: 0,
          authUsername: null,
          authPassword: null,
          username: 'chekt',
          password: 'chekt'
        },
        '9C4DB1400906': {
          name: 'Bridge #2',
          mac: '9C4DB1400906',
          isOnline: 1,
          isCheckingConnection: 0,
          isAuthenticated: 1,
          isAuthenticating: 0,
          authError: 0,
          authUsername: null,
          authPassword: null,
          username: 'chekt',
          password: 'chekt'
        }
      }
      this.selectedBridge = Object.keys(this.bridges)[0]
      this.channels = {
        1: {
          name: 'Front Door',
          mac: '31E3FCC13DCC',
          liveSnapshotUrl: 'static/download-1.jpg',
          isOnline: 1
        },
        2: {
          name: 'Backyard West',
          mac: '9113DAF4D260',
          liveSnapshotUrl: 'static/download-2.jpg',
          isOnline: 1
        },
        3: {
          name: 'Backyard East',
          mac: '76C66A969C87',
          isOnline: 0
        },
        4: {
          name: 'Pool Entrance',
          mac: '88E3950DCEA6',
          liveSnapshotUrl: 'static/download-3.jpg',
          isOnline: 1
        },
        5: {
          name: 'Pool West',
          mac: 'F160A8B88346',
          liveSnapshotUrl: 'static/download-4.jpg',
          isOnline: 1
        },
        6: {
          name: 'Warehouse entrance',
          mac: '7F6757119781',
          liveSnapshotUrl: 'static/download-5.jpg',
          isOnline: 1
        },
        7: {
          name: 'Warehouse East',
          mac: '449ED2C5290C',
          liveSnapshotUrl: 'static/download-6.jpg',
          isOnline: 1
        },
        8: {
          name: 'Second Warehouse',
          mac: '8933BC6118F8',
          isOnline: 0
        }
      }
      this.thumbnailVideoUrls = [
        'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-0.mp4',
        'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-1.mp4',
        'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-2.mp4'
      ]
    },
    checkBridgeConnection: function (mac) {
      if (!this.bridges[mac].isCheckingConnection) {
        this.bridges[mac].isCheckingConnection = 1
        setTimeout(() => {
          this.bridges[mac].isCheckingConnection = 0
          this.bridges[mac].isOnline = 1
        }, 1000)
      }
    },
    authenticateBridgeConnection: function (mac) {
      if (this.bridges[mac].authUsername && this.bridges[mac].authPassword) {
        this.bridges[mac].authError = 0
        this.bridges[mac].isAuthenticating = 1
        setTimeout(() => {
          if (this.bridges[mac].authUsername === this.bridges[mac].username && this.bridges[mac].authPassword === this.bridges[mac].password) {
            this.bridges[mac].isAuthenticating = 0
            this.bridges[mac].isAuthenticated = 1
          } else {
            this.bridges[mac].isAuthenticating = 0
            this.bridges[mac].isAuthenticated = 0
            this.bridges[mac].authError = 'Wrong username or password'
          }
        }, 1000)
      } else {
        this.bridges[mac].authError = 'Enter username and password'
      }
    },
    onClickBridge: function (mac) {
      this.selectBridge(mac)
      this.onClickAllCamera()
    },
    selectBridge: function (mac) {
      this.selectedBridge = mac
    },
    selectCamera: function (mac) {
      this.selectedCamera = mac
    },
    unselectCamera: function () {
      this.selectedCamera = null
    },
    onClickCamera: function (mac) {
      this.selectCamera(mac)
      // this.closeMenu()
      this.openCameraComponent()
    },
    onClickMenu: function () {
      this.isMenuActive = !this.isMenuActive
    },
    openMenu: function () {
      this.isMenuActive = true
    },
    closeMenu: function () {
      this.isMenuActive = false
    },
    onClickAllCamera: function () {
      this.unselectCamera()
      this.closeMenu()
    },
    onClickPlaybackTime: function () {
      if (this.isPlaybackTimePickerClosed) {
        this.openPlaybackTimePicker()
      } else {
        this.closePlaybackTimePicker()
      }
    },
    openPlaybackTimePicker: function () {
      this.isPlaybackTimePickerClosed = false
    },
    closePlaybackTimePicker: function () {
      this.isPlaybackTimePickerClosed = true
    },
    openCameraComponent: function () {
      this.isCameraComponentClosed = false
    },
    closeCameraComponent: function () {
      this.isCameraComponentClosed = true
    }
  }
}
</script>

<style scoped>
.home {
  background-color: hsl(210,30%,15%);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  user-select: none;
  transform: translateX(0px);
  transition: transform .3s;
}
.home.menuVisible {
  transform: translateX(250px);
}
.home .clickable-layer-to-close-menu {
  padding: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  z-index: -1;
  display: none;
}
.home .clickable-layer-to-close-menu.menuVisible {
  z-index: 10000;
  display: block;
}
.home .clickable-layer-to-close-menu.channelBarVisible {
  z-index: 1000;
  display: block;
  background-color: rgba(0,0,0,0.5);
}

.home .main {
  background-color: #fff;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  transform: scale(1);
  transition: transform .3s;
}
.home.menuVisible .main {
  transform: scale(0.95);
  box-shadow: 1px 1px 8px #000;
}

.home .wrapper {
  padding: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.home .header {
  position: absolute;
  top: 0;
  width: 100%;
  height: 3rem;
  z-index: 100;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  color: #000;
  background-color: rgba(255,255,255,0.35);
}
.home .header .header-title {
  width: calc(100% - 40px - 40px - 1rem);
  text-align: center;
  position: relative;
  background: transparent;
  z-index: 0;
}
.home .header .channel-btn{
  width: 40px;
  height: 40px;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
}
.home .header .channel-btn .bar{
  position: absolute;
  height: 2px;
  width: 22px;
  top: 19px;
  left: 9px;
  background-color: #000;
}
.home .header .channel-btn .bar.second{
  transform: rotate(135deg);
}
.home .header .channel-btn .bar.third{
  transform: rotate(-135deg);
}
.home .header .menu-btn{
  width: 40px;
  height: 40px;
  cursor: pointer;
  position: relative;
  margin-left: 0.5rem;
}
.home .header .menu-btn .bar{
  position: absolute;
  height: 2px;
  width: 22px;
  left: 9px;
  background-color: #000;
  transition: transform .5s, opacity .3s;
}
.home .header .menu-btn .bar.first{
  top: 13px;
}
.home .header .menu-btn .bar.second{
  top: 19px;
}
.home .header .menu-btn .bar.third{
  top: 19px;
}
.home .header .menu-btn .bar.fourth{
  top: 25px;
}
.home .header .menu-btn.active .bar.first{
  opacity: 0;
}
.home .header .menu-btn.active .bar.second{
  transform: rotate(135deg);
}
.home .header .menu-btn.active .bar.third{
  transform: rotate(-135deg);
}
.home .header .menu-btn.active .bar.fourth{
  opacity: 0;
}
.home .header .playback-btn{
  width: 40px;
  height: 40px;
  cursor: pointer;
  position: relative;
  margin-right: 0.5rem;
}
.home .header .playback-btn svg {
  fill: currentColor;
  width: 28px;
  height: 28px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}





.home .body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  transition: width .3s;
}


.home .body .cameras-container {
  padding: 0;
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: ms-autohiding-scrollbar;
}
.home .body .cameras-container::-webkit-scrollbar {
  display: none;
} 
.home .body .cameras-container:before {
  content: ' ';
  height: 100px;
  width: 100%;
}
.home .body .cameras-container:after {
  content: ' ';
  height: 80px;
  width: 100%;
}
.home .body .cameras-container .camera-container {
  width: 100%;
  max-width: 600px;
  margin: 6px;
  box-shadow: 1px 1px 4px rgba(0,0,0,0.5);  
  border-top: 3rem solid #fff;
  position: relative;
  background-color: #222;
  color: #fff;
  cursor: pointer;
}


.home .body .camera-container {
  width: 100%;
  position: relative;
  box-shadow: 1px 1px 4px rgba(0,0,0,0.5);
  background-color: #222;
  color: #fff;
  cursor: pointer;
}
.home .body .camera-container:before {
  display: block;
  content: "";
  width: 100%;
  padding-top: 56.25%;
}
.home .body .camera-container > .content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.home .body .camera-container img{
  width: 100%;
  height: 100%;
}
.home .body .camera-container .camera-info{
  width: calc(100% - 2em);
  height: 3rem;
  font-size: 14px;
  position: absolute;
  top: -3rem;
  left: 0;
  background-color: rgba(255,255,255,0.5);
  color: #333;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 1em;
}
.home .body .camera-container .camera-info .camera-name {
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: calc(100% - 120px);
}
.home .body .camera-container .camera-info .camera-name svg {
  fill: currentColor;
  margin-right: 1em;
  width: 24px;
  height: 24px;
  display: none;
}
.home .body .camera-container .camera-info .updated-info {
  padding: 0;
  width: 90px;
  font-size: 12px;
  border-left: 1px solid #ddd;
  padding-left: 1em;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.home .body .camera-container .camera-info .updated-info .updated-info-description {
  opacity: 0.3;
}
.home .body .camera-container .camera-info .updated-info .updated-info-time {
  opacity: 1;
}

.home .body .camera-wrapper {
  padding: 0;
  height: 100%;
  width: 100%;
  position: relative; 
  display: flex; 
  flex-direction: row;
  justify-content: center;
  align-items: center;
}


.home .body .authentication-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  width: 270px;
  height: 270px;
}
.home .body .authentication-container .status-text {
  font-size: 24px;
}
.home .body .authentication-container .input-container {
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}
.home .body .authentication-container .input-container > input {
  /* Remove First */
  -webkit-appearance: none;
  -moz-appearance: none;

  /* Then Style */
  border-radius: 0px;
  width: calc(100% - 2em - 2px);
  font-size: 1em;
  padding: 0 1em;
  height: 50px;
  border: 1px solid #ddd;
  outline: none;
  margin: 3px 0;
}
.home .body .authentication-container .action-btn {
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: hsla(204,60%,50%,1);
  color: #fff;
  box-shadow: 1px 1px 2px rgba(0,0,0,0.3);
  cursor: pointer;
}
.home .body .authentication-container .action-btn:active {
  box-shadow: 0 0 0;
}
.home .body .authentication-container .error-text {
  font-size: 14px;
  color: hsla(10, 100%, 50%, 0.8);
  opacity: 0;
}
.home .body .authentication-container .error-text.visible {
  opacity: 1;
}


.home .body .offline-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  width: 270px;
  height: 230px;
}
.home .body .offline-container .status-text {
  font-size: 24px;
}
.home .body .offline-container .action-btn {
  width: 200px;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: hsla(204,0%,0%,0.85); 
  border-radius: 8px;
  color: #fff;
  box-shadow: 1px 1px 2px rgba(0,0,0,0.3); 
  cursor: pointer;
}
.home .body .offline-container .action-btn svg {
  fill: currentColor;
  width: 36px;
  height: 36px;
  margin-bottom: 4px;
}
.home .body .offline-container .action-btn:active {
  box-shadow: 0 0 0;
}




.home .menu {
  width: 250px;
  border-right: 1px solid hsl(210,30%,5%);
  height: calc(100% - 2em);
  position: absolute;
  z-index: 1000;
  left: 0;
  top: 0;
  background-color: hsl(210,10%,10%);
  color: #fff;
  padding: 1em 0;
  transform: translateX(-100%);
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: ms-autohiding-scrollbar;
}
.home .menu::-webkit-scrollbar {
  display: none;
} 
.home .menu .menu-items {
  text-align: left;
  padding: 0;
}
.home .menu .menu-items .menu-category {
  font-size: 0.8em;
  padding: 1em 1.2em;
  text-transform: uppercase;
  margin-top: 2em;
  color: hsl(204, 60%, 50%);
  font-weight: bold;
}
.home .menu .menu-items .menu-item {
  padding: 1em;
  margin: 1px 0;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: rgba(255,255,255,0.04);
  transition: background .2s;
}
.home .menu .menu-items .menu-item:hover {
  background-color: rgba(255,255,255,0.06);
}
.home .menu .menu-items .menu-item:active {
  background-color: rgba(255,255,255,0.08);
}
.home .menu .menu-items .menu-item.selected {
  background-color: rgba(255,255,255,0.2);
}
.home .menu .menu-items .menu-item.selected:hover:active {
  background-color: rgba(255,255,255,0.2);
}

.home .menu .menu-items .menu-item .menu-icon {
  position: relative;
  color: hsl(204, 60%, 50%);
  margin-right: 1em;
  width: 24px;
  height: 26px;
}
.home .menu .menu-items .menu-item .menu-icon svg {
  fill: currentColor;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 24px;
  height: 24px;
}
.home .menu .menu-items .menu-item .menu-info {
  padding: 0;
}
.home .menu .menu-items .menu-item .menu-info .main-info {
  padding: 0;
  /* margin-bottom: 0.3em; */
}
.home .menu .menu-items .menu-item .menu-info .sub-info {
  padding: 0;
  font-size: 0.7em;
  opacity: 0.6;
  text-transform: uppercase;
}
.home .menu .menu-items .menu-item.offline {
  color: rgba(255,255,255,0.25);
}
.home .menu .menu-items .menu-item.offline .menu-icon {
  color: rgba(255,255,255,0.25);
}



@media screen and (min-width: 1280px) {
  .home .body{
    width: 1280px;
  }
}

@media screen and (orientation:portrait) {
  .home .footer {
    display: inherit;
  }
} 
@media screen and (orientation:landscape) {
  .home .footer {
    display: inherit;
  }
} 


</style>



// WEBPACK FOOTER //
// Home.vue?5b3b3c20